import { Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

const AlertInfo = ({
    title = "",
    content,
    footer = null,
    warning = false,
    success = false,
    error = false,
}) => {
    return (
        <Container
            fill
            column
            gap="gap.small"
            success={success}
            warning={warning}
            error={error}
        >
            {title && <ContainerTitle content={title} />}
            {content}
            {footer}
        </Container>
    );
};

export default AlertInfo;

const ContainerTitle = styled(Text)`
    font-weight: bolder;
`;

const Container = styled(Flex)`
    background: ${(props) =>
        props.warning
            ? "var(--amber-light)"
            : props.success
            ? "var(--green-light)"
            : props.error
            ? "var(--red-light)"
            : "var(--blue-light)"};
    border: 1px solid
        ${(props) =>
            props.warning
                ? "var(--amber-mid)"
                : props.success
                ? "var(--green-mid)"
                : props.error
                ? "var(--red-mid)"
                : "var(--blue-mid)"};
    border-radius: var(--radius-sm);
    padding: 12px 16px;
    font-size: 12px;
    color: ${(props) =>
        props.warning
            ? "var(--amber)"
            : props.success
            ? "var(--green)"
            : props.error
            ? "var(--red)"
            : "var(--blue)"};
    margin-bottom: 16px;
    line-height: 1.7;
`;
